/**
 * @file 项目stroe
 * @author sunyingying01
 */

import {makeObservable, observable, action} from 'mobx';

export class ProjectsStore {
    // 用户ID
    user_id: string = '';
    // 项目ID
    projectsId: string = '';
    // 项目名称
    projectsName: string = '';
    // 项目描述
    description: string = '';
    // 项目状态
    status: string = '';
    // 创建创建时间
    create_at: string = '';

    constructor() {
        makeObservable(this, {
            projectsId: observable,
            projectsName: observable,
            description: observable,
            status: observable,
            create_at: observable,
            setProjectId: action,
            setProjectName: action,
            setDescription: action,
            restoreParamFormBackend: action
        });
    }

    // 设置项目ID
    setProjectId(id: string) {
        this.projectsId = id;
    }

    // 设置项目名称
    setProjectName(name: string) {
        this.projectsName = name;
    }

    // 设置项目描述
    setDescription(desc: string) {
        this.description = desc;
    }

    restoreParamFormBackend(json: ProjectBackendData): void {
        this.projectsId = json.projects_id;
        this.projectsName = json.projects_name;
        this.description = json.description;
        this.status = json.status;
        this.create_at = json.create_at;
    }
}
